import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import { useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function RefinementCriteriaStep({
  selectedTriggerOption,
  objectTypeId,
  flow,
  setFlow,
  setValidationMessage
}) {
  var _flow$associatedLists, _flow$associatedLists2;
  const [areFiltersIncomplete, setAreFiltersIncomplete] = useState(false);
  const refinementListType = selectedTriggerOption.type === 'EVENT' ? 'REFINE_BY_LIST' : 'ENROLLMENT_LIST';
  const filterBranch = (_flow$associatedLists = (_flow$associatedLists2 = flow.associatedLists.find(list => list.listTypes.includes(refinementListType))) === null || _flow$associatedLists2 === void 0 ? void 0 : _flow$associatedLists2.filterBranch) !== null && _flow$associatedLists !== void 0 ? _flow$associatedLists : {
    filterBranches: [],
    filterBranchOperator: 'OR',
    filterBranchType: 'OR',
    filters: []
  };
  const handleFilterChange = newFilterBranch => {
    if (isFilterEmpty(newFilterBranch)) {
      setFlow(draftFlow => {
        var _draftFlow$enrollment, _draftFlow$enrollment2;
        if (((_draftFlow$enrollment = draftFlow.enrollmentCriteria) === null || _draftFlow$enrollment === void 0 ? void 0 : _draftFlow$enrollment.triggerType) === 'EVENT') {
          draftFlow.enrollmentCriteria.refinementCriteria = null;
          draftFlow.associatedLists = [];
        } else if (((_draftFlow$enrollment2 = draftFlow.enrollmentCriteria) === null || _draftFlow$enrollment2 === void 0 ? void 0 : _draftFlow$enrollment2.triggerType) === 'LIST') {
          draftFlow.enrollmentCriteria = null;
          draftFlow.associatedLists = [];
        }
      });
    } else {
      setFlow(draftFlow => {
        var _draftFlow$enrollment3;
        if (((_draftFlow$enrollment3 = draftFlow.enrollmentCriteria) === null || _draftFlow$enrollment3 === void 0 ? void 0 : _draftFlow$enrollment3.triggerType) === 'EVENT') {
          draftFlow.enrollmentCriteria.refinementCriteria = newFilterBranch;
        }
        draftFlow.associatedLists = [{
          filterBranch: newFilterBranch,
          listTypes: [refinementListType]
        }];
      });
    }
  };
  const handleFilterInfoChange = ({
    hasIncompleteFilters = false,
    hasFilterValidationErrors = false
  }) => {
    setAreFiltersIncomplete(hasIncompleteFilters || hasFilterValidationErrors);
  };
  useEffect(() => {
    if (areFiltersIncomplete) {
      setValidationMessage(I18n.text('automation-ui-enrollment.redesign.saveButton.tooltip.editingFilters'));
    } else {
      setValidationMessage(null);
    }
  }, [areFiltersIncomplete, objectTypeId, setValidationMessage]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
        baseLangKey: "createWorkflow.filterCriteriaHeader_cob",
        objectTypeId: objectTypeId
      })
    }), /*#__PURE__*/_jsx(ListSegmentationFilters, {
      value: filterBranch,
      objectTypeId: objectTypeId,
      readOnly: false,
      onFilterInfoChange: handleFilterInfoChange,
      onChange: handleFilterChange,
      hideEditCancelDiscardButton: isFilterEmpty(filterBranch),
      uiMessagesOverrides: {
        viewerEmptyFilters: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.noEnrollmentConditions"
        }),
        addFilterButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addEnrollmentCondition"
        }),
        addFilterGroupButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addEnrollmentCondition"
        }),
        editorAddFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.addEnrollmentCondition"
        }),
        editFiltersButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.editEnrollmentConditions"
        }),
        editorEditFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.redesign.review.editEnrollmentCondition"
        })
      }
    })]
  });
}
export const refinementCriteriaStep = {
  component: RefinementCriteriaStep,
  getLabel: () => I18n.text('createWorkflow.step.eligibility')
};